export enum RoutesEnum {
  Root = "occbalancing",
  Home = "home",
}
